<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-09 21:42:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/search/components/SearchTitleBar/index.vue
-->
<template>
  <div class="search_bar clearfix">
    <div class="left bar_left">
      <div class="clearfix">
        <img
          src="@/assets/search/icon_search@2x.png"
          alt=""
          class="left search_icon"
        />
        <div class="left">
          <van-field v-model="value" placeholder="" @input="changeWords" />
        </div>
      </div>
    </div>
    <div class="font14 font_weight400 cancel_bar right" @click="cancel">
      取消
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rightName: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    keyValue: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      value: ""
    };
  },
  watch: {
    keyValue(newVal) {
      this.value = newVal || "";
    }
  },
  methods: {
    back() {
      this.$emit("back");
    },
    // 取消
    cancel() {
      this.$router.back();
    },
    changeWords() {
      this.$emit("changeWords", this.value);
    }
  }
};
</script>

<style lang="less" scoped>
.search_bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 1999;
  background: #fff;
  padding: 7px 12px;
  box-sizing: border-box;
  .bar_left {
    background: #f6f7f8;
    border-radius: 20px;
    height: 34px;
    .search_icon {
      width: 24px;
      padding: 5px 12px;
    }
    ::v-deep .van-cell {
      background: #f6f7f8;
      line-height: 34px;
      border-radius: 20px;
      width: 235px;
      display: block;
      padding: 0;
    }
  }
  .cancel_bar {
    padding: 0 12px 0 24px;
    line-height: 34px;
  }
}
</style>
